module.exports = __webpack_public_path__ + "static/media/logo_white.5a3ddd63.png";